export const checkHotkeysAllowed = (disableHotKeys: boolean): boolean => {
	if (disableHotKeys) {
		return false;
	}
	if (!process.browser) {
		return false;
	}
	return !(
		document.activeElement &&
		['input', 'textarea'].indexOf(document.activeElement.localName) > -1
	);
};
